export const getMenuAccessToken = ({ menu }) => menu.get('accessToken')
export const getMenuFetchVariant = ({ menu }) => menu.get('menuVariant')
export const getMenuLimits = ({ menu }) => menu.get('menuLimits')
